// extracted by mini-css-extract-plugin
module.exports = {"opreation-button":"opreation-button-148b1a11cbac44ccaf00ada38c7636c2"};